import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class LsAccountingRouteDefinition {
  public static getRoutes(): RouteDefinition {
    return {
      path: RoutePaths.LS_ACCOUNTING,
      resolver: AlwaysShowRouteResolver,
      title: 'Accounting',
      icon: 'icon-reports.svg',
      position: 19
    };
  }
}
